<template>
  <div class="h-full flex flex-col" v-loading="saveLoading">
    <div>
      <el-page-header @back="$emit('cancel')" content="处置方法应知卡"></el-page-header>
    </div>
    <div class="flex-1 overflow-y-auto mx-200px">
      <div class="pdf-panel px-10px pt-20px" ref="card">
        <div class="w-full text-3xl text-center h-60px leading-60px bg-color-primary">
          处置方法应知卡
        </div>
        <div class="table-form border-1 border-color-default">
          <table class="table-body w-full">
            <tr>
              <td
                rowspan="9"
                class="w-1/6 border-r-1 border-b-1  border-l-1 p-10px table-cell bg-table-header"
              >
                <div>
                  事故风险分析
                </div>
              </td>
            </tr>
            <tr class="w-5/6  ">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div>事故类型</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div class="font-normal">
                  {{ formData.accidentTypeStr }}
                </div>
              </td>
            </tr>
            <tr class="">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell">
                <div>发生的区域</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell">
                <div class="font-normal">
                  {{ formData.occurredAreaStr }}
                </div>
              </td>
            </tr>
            <tr class=" ">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div>可能导致的事故</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div class="font-normal">
                  {{ formData.mayResultAccidentsStr }}
                </div>
              </td>
            </tr>
            <tr class="">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell">
                <div>可能发生的时间</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell">
                <div class="font-normal">
                  {{ formData.occurrencePossibleTime }}
                </div>
              </td>
            </tr>
            <tr class=" ">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div>影响范围</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div class="font-normal">
                  {{ formData.influenceScope }}
                </div>
              </td>
            </tr>
            <tr class="">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell">
                <div>具体位置</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell">
                <div class="font-normal">
                  {{ formData.specificLocations }}
                </div>
              </td>
            </tr>
            <tr class=" ">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div>出现的征兆</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div class="font-normal">
                  {{ formData.appearanceSigns }}
                </div>
              </td>
            </tr>
            <tr class="">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell">
                <div>次生、衍生事故</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell">
                <div class="font-normal">
                  {{ formData.derivativeAccidents }}
                </div>
              </td>
            </tr>
            <tr class="">
              <td class="w-1/6 border-r-1 border-b-1  border-l-1 p-10px table-cell bg-table-header">
                <div>应急工作职责</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div class="font-normal">
                  {{ formData.emergencyResponseTaskForceResponsibilities }}
                </div>
              </td>
            </tr>
            <tr>
              <td rowspan="5" class="w-1/6 border-r-1 border-l-1 border-b-1 p-10px table-cell">
                <div class="text-color-primary">
                  应急处置
                </div>
              </td>
            </tr>
            <tr class="w-5/6 ">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell">
                <div>应急处置程序</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell">
                <div class="font-normal">
                  {{ formData.emergencyProcedures }}
                </div>
              </td>
            </tr>
            <tr class=" ">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div>现场应急处置措施</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div class="font-normal">
                  {{ formData.onSiteDisposalMeasures }}
                </div>
              </td>
            </tr>
            <tr class="">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell">
                <div>报警电话</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell">
                <div class="font-normal">
                  {{ formData.policeCall }}
                </div>
              </td>
            </tr>
            <tr class=" ">
              <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                <div>事故报告等</div>
              </td>
              <td
                colspan="5"
                class="w-5/6 border-r-1 border-b-1 p-10px table-cell  bg-table-header"
              >
                <div class="font-normal">
                  {{ formData.accidentReportContents }}
                </div>
              </td>
            </tr>
            <tr class="">
              <td class="w-1/6 border-r-1 border-b-1 border-l-1 p-10px table-cell">
                <div>注意事项</div>
              </td>
              <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell">
                <div class="font-normal">
                  {{ formData.precautions }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="flex justify-center mt-20px">
      <el-button type="primary" size="small" @click="exportRiskCard" :disabled="saveLoading"
        >导出</el-button
      >
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import html2pdf from '@/components/safety/enumField/pdfPage'
import { DisposalMethodEmergencyCardApi } from '@wiz-api/double-prevention-management'

const disposalMethodEmergencyCardApi = new DisposalMethodEmergencyCardApi()
export default {
  name: 'deal-methods-card',
  components: {},
  props: {
    rowId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        cardName: '',
        cardNum: '',
        accidentType: null,
        occurredAreaId: undefined,
        occurrencePossibleTime: undefined,
        influenceScope: '',
        mayResultAccidents: '',
        specificLocations: '',
        appearanceSigns: '',
        derivativeAccidents: '',
        emergencyResponseTaskForceResponsibilities: '',
        emergencyProcedures: '',
        onSiteDisposalMeasures: '',
        policeCall: null,
        accidentReportContents: '',
        precautions: '',
      },
    }
  },
  mounted() {
    this.initForm()
  },
  methods: {
    // 初始化表单
    async initForm() {
      this.saveLoading = true
      const [err, res] = await disposalMethodEmergencyCardApi.get(this.rowId)
      if (!err) {
        this.formData = {
          ...this.formData,
          ...res,
        }
        this.formData.occurrencePossibleTime = this.formData.occurrencePossibleTime
          ? dayjs(this.formData.occurrencePossibleTime).format('YYYY-MM-DD HH:mm:ss')
          : undefined
      }
      this.saveLoading = false
    },
    // 导出pdf
    exportRiskCard() {
      const pdfName = '处置方法应急卡'
      html2pdf(this.$refs.card, pdfName)
    },
  },
}
</script>

<style scoped lang="scss">
.table-form {
  .table-body {
    word-break: break-all;
    font-size: 14px;
    tr:last-child {
      border: none;
    }
  }
}

::v-deep .el-card .el-card__header {
  padding: 10px;
}

::v-deep .custom-card {
  border-bottom: none !important;
}

::v-deep .el-card .el-card__header {
  padding: 0 !important;
}
</style>
